import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
});

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    todos: {
      items: [],
      index: 0,
      max: 40
      // items: [
      //   {
      //     name: "1 Write Vanilla ADSR modeller",
      //     rating: 1,
      //     approved: null,
      //     complexity: 0,
      //     duration: 0,
      //     profile: { value: 0, img: require("@/assets/blank.png") },
      //     layout: { x: -1, y: -1, scaleX: -100, scaleY: -100 }
      //   },
      //   {
      //     name: "2 Write WSJF modeller",
      //     rating: 2,
      //     approved: null,
      //     complexity: 0,
      //     duration: 0,
      //     profile: { value: 0, img: require("@/assets/blank.png") },
      //     layout: { x: -1, y: -1, scaleX: -100, scaleY: -100 }
      //   },
      //   {
      //     name: "3 Write Backlog load and model version",
      //     rating: 3,
      //     approved: null,
      //     complexity: 0,
      //     duration: 0,
      //     profile: { value: 0, img: require("@/assets/blank.png") },
      //     layout: { x: -1, y: -1, scaleX: -100, scaleY: -100 }
      //   },
      //   {
      //     name: "4 Write Midi controller",
      //     rating: 1,
      //     approved: null,
      //     complexity: 0,
      //     duration: 0,
      //     profile: { value: 0, img: require("@/assets/blank.png") },
      //     layout: { x: -1, y: -1, scaleX: -100, scaleY: -100 }
      //   },
      //   {
      //     name: "5 Write WSJF modeller",
      //     rating: 2,
      //     approved: null,
      //     complexity: 0,
      //     duration: 0,
      //     profile: { value: 0, img: require("@/assets/blank.png") },
      //     layout: { x: -1, y: -1, scaleX: -100, scaleY: -100 }
      //   },
      //   {
      //     name: "6 Write PolyValue Modeller",
      //     rating: 3,
      //     approved: null,
      //     complexity: 0,
      //     duration: 0,
      //     profile: { value: 0, img: require("@/assets/blank.png") },
      //     layout: { x: -1, y: -1, scaleX: -100, scaleY: -100 }
      //   },
      //   {
      //     name: "7 Write time based layout",
      //     rating: 1,
      //     approved: null,
      //     complexity: 0,
      //     duration: 0,
      //     profile: { value: 0, img: require("@/assets/blank.png") },
      //     layout: { x: -1, y: -1, scaleX: -100, scaleY: -100 }
      //   },
      //   {
      //     name: "8 Go phishing",
      //     rating: 2,
      //     approved: null,
      //     complexity: 0,
      //     duration: 0,
      //     profile: { value: 0, img: require("@/assets/blank.png") },
      //     layout: { x: -1, y: -1, scaleX: -100, scaleY: -100 }
      //   },
      //   {
      //     name: "9 Add Firebase DAL and email auth",
      //     rating: 3,
      //     approved: null,
      //     complexity: 0,
      //     duration: 0,
      //     profile: { value: 0, img: require("@/assets/blank.png") },
      //     layout: { x: -1, y: -1, scaleX: -100, scaleY: -100 }
      //   },
      //   {
      //     name: "10 DataAccess to both types of modeller",
      //     rating: 1,
      //     approved: null,
      //     complexity: 0,
      //     duration: 0,
      //     profile: { value: 0, img: require("@/assets/blank.png") },
      //     layout: { x: -1, y: -1, scaleX: -100, scaleY: -100 }
      //   }
      //   // { name: "11 Write Lean Scene for maintenance", rating: 2, approved: null },
      //   // { name: "12 Convert everyhting to machine code", rating: 3, approved: null}
      // ],
      // index: 0,
      // max: 10
    }
  },
  getters: {
    approvedItems: state => {
      console.log("In approved items getter");
      var approvedItems = state.todos.items.filter(item => {
        console.log(item);
        return item.approved === true;
      });
      return approvedItems;
    },
    unapprovedItems: state => {
      console.log("In approved items getter");
      var approvedItems = state.todos.items.filter(item => {
        console.log(item);
        return item.approved === null;
      });
      return approvedItems;
    }
  },

  mutations: {
    setApproval: (state, payload) => {
      // state.items.data[0].approved = true;
      let _idx = payload.index;
      console.log("Store set payload ", payload);
      state.todos.items[_idx].approved = payload.approval;
      console.log(
        "Store setting ",
        state.todos.data[state.todos.index].name,
        payload
      );
    },
    updateProfile: (state, payload) => {
      // state.items.data[0].approved = true;
      let _idx = payload.index;
      console.log("Store set payload ", payload);
      // state.todos.items[_idx].profile.value = payload.profileValue;
      state.todos.items.forEach(item => {
        if (item === _idx) {
          item.profile.value = payload.profileValue;
        }
      });
      console.log(
        "Store setting ",
        state.todos.data[state.todos.index].name,
        payload
      );
    },
    move: (state, payload) => {
      let _name = payload.name;
      state.todos.items.forEach(item => {
        // console.log("CHECKING ", item.name, "vs.", _name);
        if (item.name === _name) {
          (item.layout.x = payload.x),
            (item.layout.y = payload.y),
            (item.layout.scaleX = payload.scaleX),
            (item.layout.scaleY = payload.scaleY);
          if (payload.complexity <= 20) {
            item.complexity = payload.complexity;
          }
          item.duration = payload.duration;
        }
      });
    },
    addItem(state, payload) {
      state.todos.items.push(payload);
    },
    clearItems(state) {
      state.todos.items = [];
    }
  },
  actions: {
    setApproval: (context, payload) => {
      context.commit("setApproval", payload);
    },
    updateProfile: (context, payload) => {
      // context.commit("updateProfile", payload);

      console.log("Setting on the store", payload);
    },
    move: (context, payload) => {
      // let name = payload.name;

      console.log("MMMMMMOVING", payload.name);
      context.commit("move", payload);
    },
    addItem(context, payload) {
      context.commit("addItem", payload);
    },
    clearItems(context) {
      context.commit("clearItems");
    }
  },
  plugins: [vuexLocal.plugin]
});
